import { render } from "./list.vue?vue&type=template&id=283afe90&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=283afe90&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283afe90"],['__file',"src/views/list.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "283afe90"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('283afe90', __exports__)) {
    console.log('reload')
    api.reload('283afe90', __exports__)
  }
  
  module.hot.accept("./list.vue?vue&type=template&id=283afe90&scoped=true", () => {
    console.log('re-render')
    api.rerender('283afe90', render)
  })

}


export default __exports__